class FarmModel {
    constructor({farm , pond ,name}){
        this.farm=farm
        this.pond=pond
        this.name = name || ''
    }
}

export default FarmModel;